import { Box, Button, Typography, styled } from "@mui/material";

export const Text = styled(Typography)({
  fontSize: "13px",
  fontFamily: "Roboto",
  fontWeight: 400,
  color: "#afafaf",
});
export const DgTitle = styled(Typography)({
  color: "#4CAF50",
  fontSize: "15px",
  fontWeight: 500,
  textAlign: "center",
});
export const DTtitle = styled(Typography)({
  fontSize: "14px",
  fontWeight: 500,
  fontFamily: "Roboto",
  color: "#AFAFAF",
});
export const HeaderTitle = styled(Typography)(({ theme }) => ({
  fontSize: "18px",
  fontWeight: 600,
  fontFamily: "Roboto",
  color: "white",
  [theme.breakpoints.down("sm")]: {
    color: "#4eaf51",
    fontSize: "14px",
  },
}));
export const HeaderBtn = styled(Button)(({ theme }) => ({
  background: "white !important",
  color: "#4EAF50",
  textTransform: "none",
  fontSize: "14px",
  boxShadow: "none !important",
  [theme.breakpoints.down("sm")]: {
    background: "#4eaf51 !important",
    color: "white",
    fontSize: "12px",
  },
}));

export const Header = styled(Box)(({ theme }) => ({
  borderRadius: "4px",
  zIndex: 1,
  position: "fixed",
  minHeight: "80px",
  margin: "10px",
  padding: "1px 16px",
  background: "#4EAF50",
  display: "flex",
  alignItems: "center",
  flexWrap: "wrap",
  justifyContent: "space-between",
  top: 0,
  left: 240,
  right: 0,
  gap: "16px",
  [theme.breakpoints.down("sm")]: {
    background: "#ebebeb",
    top: 60,
    left: 0,
    margin: 0,
  },
}));
export const BodyContainer = styled(Box)(({ theme }) => ({
  position: "relative",
  top: "110px",
    overflow: "hidden",

  [theme.breakpoints.down("md")]: {
    top: "100px",
  },
  [theme.breakpoints.down("sm")]: {
    top: "140px",
  },
}));
export const CashBox = styled(Box)(({ theme }) => ({
  background: "#FFFFFF",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "8px",
  borderRadius: "6px",
  minWidth: "250px",
}));
